import scrollTo from './scroll-to';

export default {
  init() {

    const onScroll = (e) => {

      $('.services_slider__slide').each(function(i, prod){
        var prodTop = $(prod).offset().top + (parseFloat($(prod).css('height'))/3);
        var mark = window.pageYOffset + (window.innerHeight*8/9);

        if (mark > prodTop) {
          $(this).addClass('found');
        }
      });
    }

    $(window).on('scroll', onScroll);
  },
  createPagination() {
    const paginationWrap = $('#slides-paginator');
    const paginationItem = (n) => { return `<div class='item' data-slide-for='${n}'></div>`};
    $('.section__services_slider').find('.services_slider__slide').each(function() {
      let number = $(this).data('place');
      paginationWrap.append(paginationItem(number));
    });

    scrollTo.init();
  },
  changeActiveBullet() {
    const onScroll = (e) => {
      var scrollPos = $(document).scrollTop();

      $('#slides-paginator').find('.item').each(function() {
          var currLink = $(this).data("slide-for");
          var refElement = $('[data-place="' + currLink +'"]');
          
          if (refElement.position().top <= scrollPos && refElement.position().top + refElement.height() > scrollPos) {
              $('#slides-paginator .item').removeClass("act");
              $(this).addClass("act");
          }
          else{
              $(this).removeClass("act");
          }
      });
    }

    $(window).on('scroll', onScroll);
    
  }
}

